import typewriter from 'analytics/typewriter'

export const sideNavClicked = args => {
  const trackArgs = {
    target: args.label,
    workspace_slug: args.workspaceSlug
  }

  typewriter.sideNavClicked(trackArgs)

  // TODO: Drop these in favor of the `Side Nav Clicked` event above.
  if (args.label === 'Catalog') {
    typewriter.sideNavClickedCatalog(trackArgs)
  } else if (args.label === 'Destinations') {
    typewriter.sideNavClickedDestinations(trackArgs)
  } else if (args.label === 'Docs') {
    typewriter.sideNavClickedDocs(trackArgs)
  } else if (args.label === 'Health') {
    typewriter.sideNavClickedHealth(trackArgs)
  } else if (args.label === 'Overview') {
    typewriter.sideNavClickedOverview(trackArgs)
  } else if (args.label === 'Personas') {
    typewriter.sideNavClickedPersonas(trackArgs)
  } else if (args.label === 'Protocols') {
    typewriter.sideNavClickedProtocols(trackArgs)
  } else if (args.label === 'Settings') {
    typewriter.sideNavClickedSettings(trackArgs)
  } else if (args.label === 'Sources') {
    typewriter.sideNavClickedSources(trackArgs)
  }
}

export const changeWorkspaceClicked = args => {
  const trackArgs = { target: args.label }

  typewriter.changeWorkspaceClicked(trackArgs)

  // TODO: Drop these in favor of the `Change Workspace Clicked` event above.
  if (args.label === 'Account Settings') {
    typewriter.changeWorkspaceClickedFromAccountSettings(trackArgs)
  } else if (args.label === 'Workspace Settings') {
    typewriter.changeWorkspaceClickedFromWorkspaceSettings(trackArgs)
  }
}
